module.exports = __webpack_public_path__ + "img/av-lat.27cd808e.png";